<template>
	<div id="produk-create">
		<vx-card class="mb-base" title="Form Produk">
			<vue-form-generator
				tag="div"
				:schema="schema"
				:model="model"
				:options="formOptions"
				@model-updated="listen"
			></vue-form-generator>
		</vx-card>
		<div class="vx-col w-full" vs-justify="center">
			<vs-row vs-w="12" vs-type="flex" vs-justify="center">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.go(-1)"
					>
					Batal
				</vs-button>
				<vs-button
					class="mr-4 mb-4"
					icon-pack="feather"
					color="#6488e4"
					@click="onConfirm"
					>
					Simpan
				</vs-button>
			</vs-row>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
import ref from "@/api/ref.js";
import form from "@/api/form.js";
import master from "@/api/master.js";
import tool from "@/tool/form_tool.js";
import VsCurrency from "@/components/custom-form/vfg-vscurrency";
import VsInput from "@/components/custom-form/vfg-vsinput";
import VsSwitch from "@/components/custom-form/vfg-vsswitch";
import VsSelect from "@/components/custom-form/vfg-vsselect";
import VsNumber from "@/components/custom-form/vfg-vsnumber";
import VsDatePicker from "@/components/custom-form/vfg-vsdatepicker";

Vue.use(VueFormGenerator);
Vue.component("field-vscurrency", VsCurrency);
Vue.component("field-vsinput", VsInput);
Vue.component("field-vsswitch", VsSwitch);
Vue.component("field-vsselect", VsSelect);
Vue.component("field-vsnumber", VsNumber);
Vue.component("field-vsdatepicker", VsDatePicker);

export default {
	data() {
		return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			}
		};
	},
	methods: {
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: "Anda yakin untuk melanjutkan proses ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

			master.saveProduk(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/inventory/produk"
						);
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},
		listen(newVal, schema) {
		},
		async firstLoad() {
			const frm = await form.getFormProduk();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			this.model = frm.data.data[0].model;
			if (idx) {
				const xmodel = await master.getProduk(idx);
				let tmp = xmodel.data.data[0];
				tool.copyFromObjectToObject(tmp, this.model);
			}
			await this.getUOM();
			await this.getSupplier();
			await this.getProductGroup();
		},
		async getUOM() {
			const prov = await master.listUOM();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"unit",
				prov.data.data
			);
		},
		async getSupplier() {
			const prov = await master.listSupplier();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"supplier",
				prov.data.data
			);
		},
		async getProductGroup() {
			const prov = await master.listProdukGroup();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"productGroup",
				prov.data.data
			);
		},
	},
	created() {
		this.firstLoad();
	}
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
